import isNil from 'lodash/isNil';

export const EMPTY_NAME = 'EMPTY_NAME';

export const onValidate = (newValue: string) => {
	if (isNil(newValue) || newValue.trim().length < 1) {
		return EMPTY_NAME;
	}

	return undefined;
};
